import {Construtor} from './construtor';

export class AgendaRoteiroRotina implements Construtor<AgendaRoteiroRotina> {

  public idAgendaRoteiroRotina: number;
  public idAgendaRoteiroPontoFisico: number;
  public idRotinaProcesso: number;
  public selecionado: boolean;
  public alterado: boolean;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (AgendaRoteiroRotina)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(indicadorRotina: any): void {
    this.idAgendaRoteiroRotina = indicadorRotina.idAgendaRoteiroRotina;
    this.idRotinaProcesso = indicadorRotina.idRotinaProcesso;
    this.idAgendaRoteiroPontoFisico = indicadorRotina.idAgendaRoteiroPontoFisico;
  }

  copyObject(indicadorRotina: AgendaRoteiroRotina): void {
    this.idAgendaRoteiroRotina = indicadorRotina.idAgendaRoteiroRotina;
    this.idRotinaProcesso = indicadorRotina.idRotinaProcesso;
    this.idAgendaRoteiroPontoFisico = indicadorRotina.idAgendaRoteiroPontoFisico;
  }

  modeloCompleto(): boolean {
    return this.idRotinaProcesso !== undefined && this.idAgendaRoteiroPontoFisico !== undefined;
  }

  getNewInstance(object?: any): AgendaRoteiroRotina {
    return new AgendaRoteiroRotina(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/agenda-roteiro-rotina.ts